export const SHARED_TEXT_ZONE = {

  'COLLABORATIVE_EDITING': 'Editeur collaboratif',
  'COLLABORATIVE_EDITING_ERROR': 'Le service d\'édition simultanée est actuellement indisponible.'

};
